class Index {
    rc;
    _parent;
    pin;
    constructor(_parent, pin = null) {
        this._parent = _parent;
        this.rc = _parent.rc;
        this.pin = pin;
    }
    path(withParameter = true) {
        if (withParameter && this.pin !== null) {
            return `${this._parent.path()}/web/${this.pin}`;
        }
        return `${this._parent.path()}/web`;
    }
    /**
     * Finds a bridge by short identifier (Web PIN). Also it can be used to find a default bridge by the alias
     * (personal meeting name).
     *
     * HTTP Method: get
     * Endpoint: /rcvideo/v2/bridges/pin/web/{pin}
     * Rate Limit Group: Medium
     * App Permission: Video
     */
    async get(queryParams, restRequestConfig) {
        if (this.pin === null) {
            throw new Error("pin must be specified.");
        }
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
}
export default Index;
